import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {GeneralService} from '../../../services/general.service';
import {Injectable} from '@angular/core';
import {Page} from '../../../model/page';
import {IMasterCustomer} from '../interfaces/IMasterCustomer';
import * as _ from 'lodash';
import {IMasterData} from '../interfaces/IMasterData';

@Injectable()
export class MasterCustomerService extends GeneralService {

    constructor(
        protected http: HttpClient
    ) {
        super(http);
    }

    getById(id): Observable<any> {

        if (id === 0) {
            return Observable.of(this.initialize());
        }

        const url = `${this.apiUrl}/master-customer/view`;
        return this.http.get(url, {params: {CU0_ID: id}});
    }

    save(masterCustomer: IMasterCustomer, isCreate: boolean): Observable<any> {
        return isCreate ? this.create(masterCustomer) : this.update(masterCustomer);
    }

    private create(masterCustomer: IMasterCustomer): Observable<any> {
        const url = `${this.apiUrl}/master-customer/create`;
        return this.http.post(url, masterCustomer);
    }

    private update(masterCustomer: IMasterCustomer): Observable<any> {
        const url = `${this.apiUrl}/master-customer/update`;
        return this.http.post(url, masterCustomer);
    }

    public getDataList(page: Page): Observable<any> {
        const url = '/master-customer';
        return this.getRestList(page, url);
    }

    public getDataListForSelection(page): Observable<any> {
        const pageObject = new Page();
        pageObject.pageNumber = page.hasOwnProperty('pageNumber') ? page.pageNumber : 0;
        pageObject.size = page.hasOwnProperty('size') ? page.size : 50;
        pageObject.filterParams['pagination'] = 0;
        const url = '/master-customer';
        return this.getRestList(pageObject, url);
    }

    public setSelectedMasterCustomer(CU0_ID): Observable<any> {
        const url = `${this.apiUrl}/master-customer/set`;
        return this.http.post(url, {CU0_ID: CU0_ID});
    }

    public getItems(page): Observable<any> {
        const current_page = page.pageNumber;
        let params = new HttpParams();
        params = params.append('perPage', page.size);
        params = params.append('page', current_page.toString());
        if (!_.isUndefined(page.sortParams)) {
            for (const key of Object.keys(page.sortParams)) {
                const value = page.sortParams[key];
                params = params.append('sort[]', key + ',' + value );
            }
        }
        if (!_.isUndefined(page.filterParams)) {
            for (const key of Object.keys(page.filterParams)) {
                const value = page.filterParams[key];
                if (value && value !== '') {
                    params = params.append(key, value);
                }
            }
        }
        return this.http.get(this.apiUrl + '/order-entry-system/customer', { params : params });
    }

    delete(masterCustomer: IMasterCustomer): Observable<any> {
        const url = `${this.apiUrl}/master-customer/delete`;
        return this.http.post(url, masterCustomer);
    }

    public initialize() {
        return {
            CU0_ID: 0,
            CU0_SHORT_CODE: null,
            CU0_NAME: null,
            CU0_TYPE: 0,
            CU0_ALLOW_DUPLICATE_BARCODES: 0,
            CU0_ALLOW_INVENTORY_MANAGEMENT: 0,
            CU0_ENABLE_ORDER_ENTRY_USAGE_DATA_SYNCHRONIZATION: 0,
            CU0_LOGO_FILEPATH: null,
            CU0_CREATED_ON: null,
            CU0_CREATED_BY: null,
            CU0_MODIFIED_ON: null,
            CU0_MODIFIED_BY: null,
            CU0_DELETE_FLAG: 0
        };
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/oes/services/master-customer.service.ts